<div fxLayoutAlign="center center"><h2>Programme</h2></div>
<div>
    <form [formGroup]="programmeForm" fxLayoutAlign="center center" class="programme-form">
        <div fxLayout="column" fxFlex="40" fxFlex.md="50" fxFlex.sm="80" fxFlex.xs="95" fxLayoutGap="10px">
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Academic Year</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Academic Year</mat-label>
                        <mat-select [(value)]="quotationDetail.academicYear" formControlName="academicYearControl" (selectionChange)="programmeFilterChange()" placeholder="Academic Year" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select academic year">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let academicYear of academicYears" [value]="academicYear.id">{{academicYear.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="academicYearControl.hasError('min')">Academic year is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Year of study" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Degree Type</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Degree Type</mat-label>
                        <mat-select disableOptionCentering [(value)]="quotationDetail.degreeTypeId" formControlName="degreeTypeControl" (selectionChange)="programmeFilterChange()" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select degree type">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let degreeType of degreeTypes" [value]="degreeType.id">{{degreeType.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="degreeTypeControl.hasError('required')">Degree type is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Certificate, Diploma, Degree" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Graduation Type</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Graduation Type</mat-label>
                        <mat-select [(value)]="quotationDetail.gradTypeId" formControlName="gradTypeControl" (selectionChange)="programmeFilterChange()" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select graduation type">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let gradType of gradTypes" [value]="gradType.id">{{gradType.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="gradTypeControl.hasError('required')">Graduation type is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Undergraduate or Postgraduate" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Study Type</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Study Type</mat-label>
                        <mat-select [(value)]="quotationDetail.studyTypeId" formControlName="studyTypeControl" (selectionChange)="programmeFilterChange()" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select study type">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let studyType of studyTypes" [value]="studyType.id">{{studyType.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="studyTypeControl.hasError('required')">Study type is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Full Time or Part Time" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Faculty</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Faculty</mat-label>
                        <mat-select [(value)]="quotationDetail.facultyId" formControlName="facultyControl" (selectionChange)="programmeFilterChange()" [disableOptionCentering]="true" panelClass="mat-select-dropdown-custom" placeholder="Select faculty">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let faculty of faculties" [value]="faculty.id">{{faculty.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="facultyControl.hasError('required')">Faculty is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Academic base / home in which programme is offered?" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Programme</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Programme</mat-label>
                        <mat-select [(value)]="quotationDetail.programmeId" formControlName="programmeControl" (selectionChange)="programmeChanged($event.value)" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select programme">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let programme of programmes" [value]="programme.id">{{programme.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="programmeControl.hasError('min')">Programme is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Course of study" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Programme Stream</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat" hideRequiredMarker>
                        <mat-label fxHide.gt-xs>Programme Stream</mat-label>
                        <mat-select [(value)]="quotationDetail.streamId" [required]='streams.length > 0' formControlName="streamControl" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select programme stream">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let stream of streams" [value]="stream.id">{{stream.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="streamControl.hasError('required')">Programme stream is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Area of specialisation within a selected programme" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div>
                <div fxLayout="row">
                    <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Year Level</mat-label></div>
                    <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                        <mat-label fxHide.gt-xs>Year Level</mat-label>
                        <mat-select [(value)]="quotationDetail.yearLevelId" formControlName="yearLevelControl" [disableOptionCentering]="true"  panelClass="mat-select-dropdown-custom" placeholder="Select programme year level">
                            <mat-option>---</mat-option>
                            <mat-option *ngFor="let yearLevel of yearLevels" [value]="yearLevel.id">{{yearLevel.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="yearLevelControl.hasError('min')">Year level is required</mat-error>
                    </mat-form-field>
                    <mat-label class="mat-label-tooltip" matTooltip="Level of study, 1st, 2nd, 3rd, 4th" matTooltipPosition="left">
                        <mat-icon>info</mat-icon>
                    </mat-label>
                </div>
            </div>
            <div fxFlex="row" class="navigation-container">
                <div fxFlex="50" fxLayoutAlign="start center">
                    <button mat-button [routerLink]="['/default', {outlets: {'main': ['disclaimer']}}]" class="navigation-button navigation-button-back">Back</button>
                </div>
                <div fxFlex="50" fxLayoutAlign="end center">
                    <button mat-button (click)="proceed()" class="navigation-button navigation-button-proceed">Proceed</button>
                </div>
            </div>
        </div>
    </form>
</div>
